import { createContext } from 'react';

/// O que o diálogo de mês fechado precisa da casca: quem pode o quê, o dia de hoje e como abrir o
/// Fechamento. Fora da casca (num teste de tela isolada) não há contexto, e a recusa de mês
/// fechado segue como erro comum.
export interface ClosedPeriodScope {
  canAdjust: boolean;
  canReopen: boolean;
  today: string;
  openClosing: () => void;
}

export const ClosedPeriodContext = createContext<ClosedPeriodScope | null>(null);
